<template>
    <div class="device-groups-component">
        <Protector v-if="displayProtector" />
        <b-container fluid>
            <b-row>
                <b-col>
                    <DeviceGroupEditor
                        :group-selected="onGroupSelected"
                    />
                </b-col>
                <b-col cols="8">
                    <DeviceGroupDevicesEditor
                        :group="selectedGroup"
                        :on-busy="toggleProtector"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script lang="ts">
import Component from "vue-class-component";
import Vue from "vue";
import {IDeviceGroupDto} from "../../Repository/DeviceGroup/Dto/IDeviceDto";
import Protector from "../Common/Protector.vue";
import DeviceGroupEditor from "./DeviceGroupEditor.vue";
import DeviceGroupDevicesEditor from "./DeviceGroupDevicesEditor.vue";

@Component({
    components: { Protector, DeviceGroupEditor, DeviceGroupDevicesEditor }
})
class DeviceGroups extends Vue {
    selectedGroup: IDeviceGroupDto|null = null;
    displayProtector: boolean = false;

    onGroupSelected(item: IDeviceGroupDto|null) {
        this.selectedGroup = item;
    }

    toggleProtector(show: boolean) {
        this.displayProtector = show;
    }
}

export default DeviceGroups;
</script>

<style lang="scss" scoped>
    @import '../../custom1.scss';

    .device-groups-component {
        position: relative;
        
        .toolbar {
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            align-items: center;
            padding: 1em 0 1em 0;

            * {
                margin-right: 0.5em;
            }
        }

        .device-groups-list {
            list-style: none;
            padding: 0;
            margin: 0;

            .device-groups-list-item {
                @include dark-list;

                .list-item-container {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .list-item-toolbar {
                        @include no-select;

                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        * {
                            margin-left: 0.5em;

                            &:hover {
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        .confirmation {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .actionbar {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                * {
                    padding: 0.5em 2em 0.5em 2em;
                    min-width: 7em;
                    margin-right: 1em;

                    *:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
